export const getUsers = (state: { users: { users: any } }) => state.users.users
